/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import _ from 'lodash';

export default function EmptyPage({ text, subtext }) {
    return (
        <div className={`flex justify-center items-center overflow-auto h-[calc(100vh-375px)]`}>
            <div className="flex flex-col text-center ">
                <img src="/assets/images/empty.png" className={'pb-6'} alt="" loading='lazy' />
                <p className=" text-lg font-normal text-black">
                    {text} <br/>
                    {subtext}
                </p>
            </div>
        </div>
    )
}
